import { compose, pure } from 'recompose';

import JumpToRecentMessagesButton from './jumpToRecentMessagesButton';

const enhance = compose(
  pure,
);

export default enhance(JumpToRecentMessagesButton);
